var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "960px", scrollable: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "ma-0",
                    attrs: {
                      flat: "",
                      icon: "",
                      color: "green accent-3",
                      title: "Contacter le support"
                    }
                  },
                  on
                ),
                [
                  _c("v-icon", { attrs: { size: "25" } }, [
                    _vm._v("contact_support")
                  ])
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("div", {
        directives: [
          {
            name: "shortkey",
            rawName: "v-shortkey",
            value: ["esc"],
            expression: "['esc']"
          }
        ],
        on: {
          shortkey: function($event) {
            _vm.dialog = false
          }
        }
      }),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "background" },
        [
          _c(
            "v-card-title",
            { staticClass: "py-1 background darken-1 " },
            [
              _c("span", [
                _c("div", { staticClass: "headline" }, [
                  _vm._v("\n\t\t\t\t\tSupport Gravity\n\t\t\t\t")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "font-italic" }, [
                  _vm._v(
                    "\n\t\t\t\t\tVeuillez préciser votre demande\n\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ma-0 ml-5",
                  attrs: { large: "", icon: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.dialog = false
                    }
                  }
                },
                [_c("v-icon", { attrs: { large: "" } }, [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pt-2" },
            [
              _c("span", { staticClass: "subheading" }, [_vm._v("Sujet")]),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "inputs mb-2",
                attrs: { solo: "", "hide-details": "" },
                model: {
                  value: _vm.title,
                  callback: function($$v) {
                    _vm.title = $$v
                  },
                  expression: "title"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "subheading" }, [
                _vm._v("Description")
              ]),
              _vm._v(" "),
              _c("v-textarea", {
                staticClass: "inputs mb-2",
                attrs: {
                  solo: "",
                  "hide-details": "",
                  rows: 5,
                  "auto-grow": ""
                },
                model: {
                  value: _vm.what,
                  callback: function($$v) {
                    _vm.what = $$v
                  },
                  expression: "what"
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "subheading" }, [
                _vm._v("Pièces jointes")
              ]),
              _vm._v(" "),
              _vm.dialog
                ? _c("Attachment", {
                    attrs: { items: _vm.attachments },
                    on: {
                      add: function($event) {
                        return _vm.addAttachment($event)
                      },
                      delete: function($event) {
                        return _vm.removeAttachment($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "text-none",
                  attrs: { color: "background darken-1" },
                  on: {
                    click: function($event) {
                      _vm.dialog = false
                    }
                  }
                },
                [_vm._v("\n\t\t\t\tAnnuler\n\t\t\t")]
              ),
              _vm._v(" "),
              Object.keys(_vm.attachments).length > 0
                ? _c(
                    "v-btn",
                    {
                      staticClass: "text-none",
                      attrs: { flat: "", color: "warning" },
                      on: {
                        click: function($event) {
                          _vm.attachments = {}
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\tSupprimer les pièces jointes\n\t\t\t")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "text-none",
                  attrs: {
                    color: "primary color--text",
                    loading: _vm.loading,
                    disabled: _vm.disabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.sendTicket()
                    }
                  }
                },
                [_vm._v("\n\t\t\t\tEnvoyer\n\t\t\t")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78aa2e41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78aa2e41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/about/ticket_form.vue
// module id = null
// module chunks = 